<template>
  <div class="footer">
    <v-container class="text-center">
      <!-- Logo -->
      <v-row justify="center" class="mb-8">
        <v-col cols="12" class="d-flex justify-center">
          <img
            v-if="settings.logo"
            :src="settings.logo"
            alt="Logo"
            height="60"
            class="footer-logo"
          />
        </v-col>
      </v-row>

      <!-- Business Info -->
      <v-row justify="center" class="mb-8">
        <v-col cols="12" sm="10" md="8">
          <v-row class="business-info justify-center">
            <v-col cols="12" sm="6" md="3" v-if="settings.business?.name">
              <div class="info-label">Name</div>
              <div class="info-value">{{ settings.business.name }}</div>
            </v-col>
            <v-col cols="12" sm="6" md="3" v-if="settings.business?.phone">
              <div class="info-label">Phone</div>
              <div class="info-value">{{ settings.business.phone }}</div>
            </v-col>
            <v-col cols="12" sm="6" md="3" v-if="settings.business?.email">
              <div class="info-label">Email</div>
              <div class="info-value">{{ settings.business.email }}</div>
            </v-col>
            <v-col cols="12" sm="6" md="3" v-if="settings.business?.address">
              <div class="info-label">Address</div>
              <div class="info-value">{{ settings.business.address }}</div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- Social Links -->
      <v-row justify="center" class="mb-8">
        <v-col cols="auto">
          <div class="d-flex justify-center">
            <a
              v-if="settings.social_links?.facebook"
              :href="settings.social_links.facebook"
              target="_blank"
              class="social-link mx-2"
            >
              <div class="social-container">
                <v-icon size="20">mdi-facebook</v-icon>
              </div>
            </a>
            <a
              v-if="settings.social_links?.instagram"
              :href="settings.social_links.instagram"
              target="_blank"
              class="social-link mx-2"
            >
              <div class="social-container">
                <v-icon size="20">mdi-instagram</v-icon>
              </div>
            </a>
          </div>
        </v-col>
      </v-row>

      <!-- Footer Links -->
      <v-row justify="center">
        <v-col
          cols="auto"
          v-if="settings?.pages?.privacy?.active || settings?.privacy?.active"
        >
          <router-link
            :to="
              settings?.pages?.privacy?.active
                ? '/privacy'
                : { name: 'privacy' }
            "
            class="footer-link mx-2"
          >
            Privacy Policy
          </router-link>
        </v-col>
        <v-col
          cols="auto"
          v-if="settings?.pages?.terms?.active || settings?.terms?.active"
        >
          <router-link
            :to="settings?.pages?.terms?.active ? '/terms' : { name: 'terms' }"
            class="footer-link mx-2"
          >
            Terms and Conditions
          </router-link>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { COMPANY_NAME } from "@/consts/CMS";
import MediaMixin from "@/mixins/media-mixin";
import { mapState } from "vuex";

export default {
  name: "site-footer",
  mixins: [MediaMixin],
  data: () => ({
    COMPANY_NAME,
  }),
  computed: {
    ...mapState({
      settings: (state) => state.settingsModule.settings,
    }),
    isAgentSite() {
      return this.settings.site_type === "agent";
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  background-color: #1e1e1e;
  color: white;
  padding: 60px 0;
}

.footer-logo {
  filter: brightness(0) invert(1);
}

.business-info {
  .info-label {
    color: #9ca3af;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 4px;
    text-transform: uppercase;
  }

  .info-value {
    color: white;
    font-size: 16px;
    margin-bottom: 24px;
  }
}

.social-link {
  text-decoration: none;
  transition: transform 0.2s;

  &:hover {
    transform: translateY(-2px);

    .social-container {
      background-color: #f3f4f6;
    }
  }
}

.social-container {
  background-color: white;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;

  .v-icon {
    color: #1e1e1e;
  }
}

.footer-link {
  color: white;
  text-decoration: none;
  font-size: 14px;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }
}

@media (max-width: 600px) {
  .business-info {
    text-align: center;
  }
}
</style>
